var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecipientIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5408_1223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 10.0002C11.8423 10.0002 13.334 8.5085 13.334 6.66683C13.334 4.82516 11.8423 3.3335 10.0007 3.3335C8.15898 3.3335 6.66732 4.82516 6.66732 6.66683C6.66732 8.5085 8.15898 10.0002 10.0007 10.0002ZM10.0007 11.6668C7.77565 11.6668 3.33398 12.7835 3.33398 15.0002V15.8335C3.33398 16.2918 3.70898 16.6668 4.16732 16.6668H15.834C16.2923 16.6668 16.6673 16.2918 16.6673 15.8335V15.0002C16.6673 12.7835 12.2257 11.6668 10.0007 11.6668Z",
    fill: "#4968D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5408_1223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipientIcon);
export default __webpack_public_path__ + "static/media/recipient-icon.60872fedf7d721d10921dc9daa320eef.svg";
export { ForwardRef as ReactComponent };